export default "__VITE_ASSET__BraUokNo__"